import React, { useState } from 'react';
import SignatureModal from 'components/app/SignatureModal';
import { Button, Row, Col } from 'react-bootstrap';
import { userAPI } from 'utils/api/fulcrum-api';
import { toast } from 'react-toastify';

const UserSignature = ({ user, setUser }) => {
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [sigBase64, setSigBase64] = useState(user?.signature || null);

  // Convert to base64
  const convertToBase64 = () => {
  }

  // Apply Signature
  const applySignature = async (data) => {
    setSigBase64(data?.signature || null);
    setShowSignatureModal(false);
    try {
      // Save signature to user
      let result = await userAPI.updateUser(user.id, { signature: data?.signature });
      if (!result?.data) { throw new Error('No data found'); }
      console.log(result);
      setUser({ ...user, signature: data?.signature });
    } catch (error) {
      console.error(error);
      toast.error('Error saving signature', { theme: 'colored' });
    }
  };

  return (
    <div >
      <SignatureModal
        modalState={showSignatureModal}
        setModalState={setShowSignatureModal}
        callBack={applySignature}
      />

      <h5>Set Signature</h5>
      {/* <img src={sigBase64 || "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="} alt="Signature" style={{ height: "50px", width: "200px" }} /> */}
      {
        (user?.signature && sigBase64) ?
          <img
            src={sigBase64 || "data:image/png;base64,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"}
            alt="Signature"
            className="border"
            style={{ height: "50px", width: "200px" }}
          />
          :
          <div className="bg-200 border" style={{ height: "50px", width: "200px" }}>

          </div>
      }
      <br />
      {" "}
      <Button variant="link" onClick={() => setShowSignatureModal(true)}>Set Signature</Button>
      {/* @todo: ensure front end and backend only allow current user to update their signature and not an staff or admin changing other signatures */}

    </div>
  );
};

export default UserSignature;